/*

Envy by WeTheme (http://www.wetheme.com)
Custom JS also by Adam Jones (http://www.adam-makes-websites.com)
Last Updated: 11/09/2026
*/


$(document).ready(function() {
	
  	// Load cart drawer when it opens
  	$(document).on('cart:open', function() {
  		setTimeout(function() {
  			loadCartDrawerContent();
  		}, 100);
  	});
  	
  	function loadCartDrawerContent() {
  		$.ajax({
  			url: '/cart.js',
  			type: 'GET',
  			dataType: 'json',
  			success: function(cart) {
  				refreshCartDrawer(cart);
  			},
  			error: function(xhr, status, error) {
  				console.error('Error loading cart:', error);
  			}
  		});
  	}
  	
  	// Cart drawer functionality - quantity updates and item removal
  	$(document).on('click', '.cart-item-quantity-plus', function(e) {
  		e.preventDefault();
  		var $btn = $(this);
  		var line = $btn.data('line');
  		var variantId = $btn.data('variant-id');
  		var $quantity = $('.cart-item-quantity[data-line="' + line + '"]');
  		var currentQty = parseInt($quantity.text()) || 0;
  		updateCartQuantity(line, variantId, currentQty + 1);
  	});
  	
  	$(document).on('click', '.cart-item-quantity-minus', function(e) {
  		e.preventDefault();
  		var $btn = $(this);
  		var line = $btn.data('line');
  		var variantId = $btn.data('variant-id');
  		var $quantity = $('.cart-item-quantity[data-line="' + line + '"]');
  		var currentQty = parseInt($quantity.text()) || 0;
  		if (currentQty > 1) {
  			updateCartQuantity(line, variantId, currentQty - 1);
  		}
  	});
  	
  	$(document).on('click', '.cart-item-remove', function(e) {
  		e.preventDefault();
  		var line = $(this).data('line');
  		removeCartItem(line);
  	});
  	
  	function updateCartQuantity(line, variantId, quantity) {
  		$.ajax({
  			url: '/cart/change.js',
  			type: 'POST',
  			dataType: 'json',
  			data: {
  				id: variantId,
  				quantity: quantity
  			},
  			success: function(cart) {
  				refreshCartDrawer(cart);
  			},
  			error: function(xhr, status, error) {
  				console.error('Error updating cart:', error);
  				alert('Error updating cart. Please try again.');
  			}
  		});
  	}
  	
  	function removeCartItem(line) {
  		var $item = $('.cart-drawer-item[data-line="' + line + '"]');
  		var variantId = $item.data('variant-id');
  		
  		if (!variantId) {
  			// Fallback: get variant ID from cart
  			$.ajax({
  				url: '/cart.js',
  				type: 'GET',
  				dataType: 'json',
  				success: function(cart) {
  					if (cart.items && cart.items.length >= line) {
  						var itemToRemove = cart.items[line - 1];
  						if (itemToRemove) {
  							removeItemByVariantId(itemToRemove.variant_id);
  						}
  					}
  				},
  				error: function(xhr, status, error) {
  					console.error('Error fetching cart:', error);
  				}
  			});
  		} else {
  			removeItemByVariantId(variantId);
  		}
  	}
  	
  	function removeItemByVariantId(variantId) {
  		$.ajax({
  			url: '/cart/change.js',
  			type: 'POST',
  			dataType: 'json',
  			data: {
  				id: variantId,
  				quantity: 0
  			},
  			success: function(updatedCart) {
  				refreshCartDrawer(updatedCart);
  			},
  			error: function(xhr, status, error) {
  				console.error('Error removing item:', error);
  				alert('Error removing item. Please try again.');
  			}
  		});
  	}
  	
  	function refreshCartDrawer(cart) {
  		// Update cart drawer HTML
  		var $cartDrawer = $('#cartSlideoutWrapper');
  		var itemsHtml = '';
  		
  		if (cart.items && cart.items.length > 0) {
  			cart.items.forEach(function(item, index) {
  				// Add divider before each item except the first one
  				if (index > 0) {
  					itemsHtml += '<hr class="cart-drawer-divider">';
  				}
  				
  				var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
  				// Display variant info - show as-is
  				var variantLabel = variantTitle;
  				var variantHtml = variantTitle ? '<div class="cart-item-variant">' + variantLabel + '</div>' : '';
  				// Get image URL - Shopify cart API provides image as a URL string
  				var imageUrl = item.image || (item.featured_image && item.featured_image.url) || (item.featured_image && item.featured_image) || '';
  				
  				itemsHtml += '<div class="cart-drawer-item" data-line="' + (index + 1) + '" data-variant-id="' + item.variant_id + '">';
  				itemsHtml += '<div class="cart-item-image">';
  				itemsHtml += '<a href="' + (item.product_url || item.url || '#') + '" target="_blank" title="' + (item.title || '').replace(/"/g, '&quot;') + '">';
  				itemsHtml += '<img src="' + imageUrl + '" alt="' + (item.title || '').replace(/"/g, '&quot;') + '" />';
  				itemsHtml += '</a></div>';
  				itemsHtml += '<div class="cart-item-details">';
  				itemsHtml += '<div class="cart-item-header">';
  				itemsHtml += '<a href="' + (item.product_url || item.url || '#') + '" target="_blank" class="cart-item-title">' + (item.product_title || item.title || '') + '</a>';
  				itemsHtml += '<button type="button" class="cart-item-remove" data-line="' + (index + 1) + '" aria-label="Remove item">×</button>';
  				itemsHtml += '</div>';
  				itemsHtml += variantHtml;
  				itemsHtml += '<div class="cart-item-quantity-wrapper">';
  				itemsHtml += '<button type="button" class="cart-item-quantity-btn cart-item-quantity-minus" data-line="' + (index + 1) + '" data-variant-id="' + item.variant_id + '">−</button>';
  				itemsHtml += '<span class="cart-item-quantity" data-line="' + (index + 1) + '">' + item.quantity + '</span>';
  				itemsHtml += '<button type="button" class="cart-item-quantity-btn cart-item-quantity-plus" data-line="' + (index + 1) + '" data-variant-id="' + item.variant_id + '">+</button>';
  				itemsHtml += '</div>';
  				itemsHtml += '<div class="cart-drawer-line-price">';
  				if (typeof formatMoney !== 'undefined') {
  					itemsHtml += formatMoney(item.line_price);
  				} else {
  					itemsHtml += '<span class="money">$' + (item.line_price / 100).toFixed(2) + '</span>';
  				}
  				itemsHtml += '</div>';
  				itemsHtml += '</div></div>';
  			});
  			
  			var footerHtml = '<hr class="cart-drawer-divider">';
  			footerHtml += '<div class="cart-drawer-footer">';
  			footerHtml += '<div class="cart-drawer-summary">';
  			footerHtml += '<div class="cart-shipping-note">Shipping & taxes calculated at checkout</div>';
  			footerHtml += '<div class="cart-subtotal">';
  			footerHtml += '<span class="cart-subtotal-label">Subtotal:</span>';
  			footerHtml += '<span class="cart-subtotal-price" id="cart-price">';
  			if (typeof formatMoney !== 'undefined') {
  				footerHtml += formatMoney(cart.total_price);
  			} else {
  				footerHtml += '<span class="money">$' + (cart.total_price / 100).toFixed(2) + '</span>';
  			}
  			footerHtml += '</span>';
  			footerHtml += '</div>';
  			footerHtml += '</div>';
  			footerHtml += '<div class="slide-checkout-buttons">';
  			footerHtml += '<a href="/cart" class="btn btn-success">Your Cart</a>';
  			footerHtml += '<a href="#sidr" class="btn btn-default cart-menu-close">Continue Shopping</a>';
  			footerHtml += '</div></div>';
  			
  			$cartDrawer.html('<div class="cart-drawer-header"><h2 class="cart-drawer-title">Your Cart</h2><a href="#sidr" class="cart-drawer-close cart-menu-close">×</a></div><div class="cart-drawer-items" id="cart-drawer-items">' + itemsHtml + '</div>' + footerHtml);
  		} else {
  			$cartDrawer.html('<div class="cart-drawer-header"><h2 class="cart-drawer-title">Your Cart</h2><a href="#sidr" class="cart-drawer-close cart-menu-close">×</a></div><div class="cart-drawer-empty"><p>Your cart is empty</p></div>');
  		}
  		
  		$('.cart-item-count, .cart-item-count-header').text(cart.item_count);
  		
  		// Re-initialize drawer close handlers
  		$('.cart-menu-close').off('click').on('click', function(e) {
  			e.preventDefault();
  			if (window.slideouts && window.slideouts.right) {
  				window.slideouts.right.close();
  			}
  		});
  	}
	
    // Handle variant tile clicks - new tiled interface
    $(document).on('click', '.variant-tile', function(event){
      event.preventDefault();
      var $tile = $(this);
      var $tilesContainer = $tile.closest('.variant-tiles');
      var optionIndex = $tile.data('option-index');
      var optionValue = getTileOptionValue($tile);
      var isSplit = $tilesContainer.data('is-split') === true;
      var splitType = $tile.data('split-type');
      
      // Allow selection of any tile (including out-of-stock) for waiting list functionality
      // Remove selected class from all tiles in this group
      $tilesContainer.find('.variant-tile').removeClass('variant-tile-selected');
      // Add selected class to clicked tile
      $tile.addClass('variant-tile-selected');
      
      if (isSplit) {
        // Handle split options (Color - Size)
        var $colorTile = $('.variant-tiles[data-split-type="color"] .variant-tile-selected');
        var $sizeTile = $('.variant-tiles[data-split-type="size"] .variant-tile-selected');
        
        if ($colorTile.length && $sizeTile.length) {
          var colorValue = getTileOptionValue($colorTile);
          var sizeValue = getTileOptionValue($sizeTile);
          var combinedValue = colorValue + ' - ' + sizeValue;
          
          // Update the main hidden select with combined value
          var $mainProductSelect = $("#ProductSelect-product-template, #ProductSelect-indiv-product");
          if ($mainProductSelect.length) {
            // Find variant with matching combined option value
            var $matchingOption = $mainProductSelect.find('option[data-name="' + combinedValue + '"]');
            if ($matchingOption.length) {
              $mainProductSelect.val($matchingOption.val()).trigger('change');
            }
          }
        }
        
        // Update hidden selects
        var $hiddenSelect = $tilesContainer.siblings('.variant-select-hidden');
        if ($hiddenSelect.length) {
          $hiddenSelect.val(optionValue).trigger('change');
        }
      } else {
        // Normal option handling
        var $hiddenSelect = $tilesContainer.siblings('.variant-select-hidden');
        if ($hiddenSelect.length) {
          $hiddenSelect.val(optionValue).trigger('change');
        }
      }
      
      // Update variant selection
      updateVariantFromTiles();
    });
    
    // Fallback: still listen for hidden select changes (in case theme JS updates them)
    $(document).on('change', '.variant-select-hidden', function(event){
      updateVariantFromTiles();
    });
  
    // lightbox for products
   const $dynamicGallery = document.getElementById('product_images');
   if ($dynamicGallery && typeof lightGallery !== 'undefined') {
     const galleryPlugins = [lgZoom];
     if (typeof lgVideo !== 'undefined') {
       galleryPlugins.push(lgVideo);
     }

     const dynamicGallery = lightGallery($dynamicGallery, {
          speed: 300,
          selector: '.image-swap',
          plugins: galleryPlugins,
          download: false,
          autoplayFirstVideo: true,
          autoplayVideoOnSlide: true,
          gotoNextSlideOnVideoEnd: false
      });

      $(document).on('click','.masterImage', function(event){
        if ($(this).hasClass('hide') || !$(this).is(':visible')) {
          return;
        }
        dynamicGallery.openGallery();
      });

      var matchVideoThumbSize = function() {
        var $firstImage = $('#product-thumbnails a.image-swap:not(.product-video-thumb) img').first();
        var $videoThumbs = $('#product-thumbnails .product-video-thumb');
        if (!$firstImage.length || !$videoThumbs.length) {
          return;
        }
        var width = $firstImage.outerWidth();
        var height = $firstImage.outerHeight();
        if (width > 0 && height > 0) {
          $videoThumbs.css('aspect-ratio', width + ' / ' + height);
        }
      };
      matchVideoThumbSize();
      $(window).on('load resize', matchVideoThumbSize);
   }


    // sizing page jump links 
    $('.styleindextable a[href^="#"]').on('click', function(e) {
        e.preventDefault();
        var target = $(this.getAttribute('href'));
        if(target.length) {
            $('html, body').animate({
                scrollTop: target.offset().top - 80
            }, 500);
        }
    });
  
});





$(window).load(function() {
  	// Initialize variant tiles - update price/stock status on page load
    updateVariantFromTiles();
});

// Responsive tables init
$(document).ready(function() {
	$('.product-description-wrapper table').wrap('<div class="rte__table-wrapper"></div>');
});

// Wow Animation init
$(document).ready(function() {
  new WOW().init();
});

// Mobile Browser Menu
$("select#mobile-menu").change(function() {
  window.location = $(this).find("option:selected").val();
});

// FancyBox
$(document).ready(function() {
	$(".fancybox").fancybox();
});

$(document).ready(function() {
	$(".fancybox-instagram").fancybox({
		padding : 0
	});
});

// Login Boxes
$("#forgot-password-box").click(function(){
    $("#customer-login").hide();
    $("#recover-password").show();
});

$("#login-box-link").click(function(){
	$("#customer-login").show();
	$("#recover-password").hide();
});

// Drawers
var MOBILE_DRAWER_SIZE = 300,
    DESKTOP_DRAWER_SIZE = 390,
    MOBILE_WIDTH_MAX = 860;

window.slideouts = {};


// Simulate responsiveness of the Drawer component
$(window).resize(function () {
    var is_mobile = document.body.clientWidth < MOBILE_WIDTH_MAX;

    // Disable mobile drawer on desktop
    window.slideouts.left._touch = is_mobile;

    // Resize right drawer based on window width
    var slideout = window.slideouts.right,
        padding = (is_mobile) ? MOBILE_DRAWER_SIZE : DESKTOP_DRAWER_SIZE;
    slideout._translateTo = slideout._padding = padding * slideout._orientation;
    if (slideout._opened) {
        var transform = "translateX(" + (padding * slideout._orientation) + "px)";
        slideout.panel.style.webkitTransform = transform;
        slideout.panel.style.transform = transform;
    }
});



function getProductJsonFromPage() {
    var $productJson = $('script[id^="ProductJson-"]');
    if (!$productJson.length) {
        return null;
    }
    try {
        return JSON.parse($productJson.html());
    } catch (e) {
        console.error('Failed to parse product JSON:', e);
        return null;
    }
}

function getTileOptionValue($el) {
    var value = $el.attr('data-option-value');
    if (value === undefined || value === null || value === '') {
        return null;
    }
    return String(value);
}

function optionValuesMatch(a, b) {
    if (a == null || b == null) {
        return false;
    }
    return String(a) === String(b);
}

function parseCombinedVariantOption(combined) {
    if (!combined) {
        return null;
    }
    var idx = String(combined).lastIndexOf(' - ');
    if (idx === -1) {
        return null;
    }
    return {
        color: combined.substring(0, idx),
        size: combined.substring(idx + 3)
    };
}

function isSizeOptionTiles($container) {
    if ($container.data('split-type') === 'size') {
        return true;
    }
    var optionName = ($container.data('option-name') || '').toString().toLowerCase();
    return optionName === 'size';
}

function isColourOptionTiles($container) {
    if ($container.data('split-type') === 'color') {
        return true;
    }
    var optionName = ($container.data('option-name') || '').toString().toLowerCase();
    return optionName === 'color' || optionName === 'colour';
}

function getSizeOptionIndex(productJson) {
    var sizeIndex = null;
    $('.variant-tiles').each(function() {
        if (isSizeOptionTiles($(this))) {
            sizeIndex = parseInt($(this).data('option-index'), 10);
            return false;
        }
    });
    if (sizeIndex !== null && !isNaN(sizeIndex)) {
        return sizeIndex;
    }
    if (productJson && productJson.options) {
        for (var i = 0; i < productJson.options.length; i++) {
            if (productJson.options[i].toLowerCase() === 'size') {
                return i;
            }
        }
    }
    return null;
}

function updateSplitVariantTileAvailability(productJson, $splitColorTiles, $splitSizeTiles) {
    var selectedSize = getTileOptionValue($splitSizeTiles.find('.variant-tile-selected'));

    $splitSizeTiles.find('.variant-tile').each(function() {
        var $tile = $(this);
        var sizeValue = getTileOptionValue($tile);
        var hasAvailable = false;

        for (var i = 0; i < productJson.variants.length; i++) {
            var variant = productJson.variants[i];
            var parsed = parseCombinedVariantOption(variant.options[0]);
            if (!parsed || !optionValuesMatch(parsed.size, sizeValue)) {
                continue;
            }
            if (variant.available) {
                hasAvailable = true;
                break;
            }
        }

        $tile.toggleClass('variant-tile-out-of-stock', !hasAvailable);
        $tile.attr('data-has-available', hasAvailable ? 'true' : 'false');
    });

    $splitColorTiles.find('.variant-tile').each(function() {
        var $tile = $(this);
        var colorValue = getTileOptionValue($tile);
        var hasAvailable = false;

        for (var j = 0; j < productJson.variants.length; j++) {
            var colorVariant = productJson.variants[j];
            var parsedColor = parseCombinedVariantOption(colorVariant.options[0]);
            if (!parsedColor || !optionValuesMatch(parsedColor.color, colorValue)) {
                continue;
            }
            if (selectedSize && !optionValuesMatch(parsedColor.size, selectedSize)) {
                continue;
            }
            if (colorVariant.available) {
                hasAvailable = true;
                break;
            }
        }

        $tile.toggleClass('variant-tile-out-of-stock', !hasAvailable);
        $tile.attr('data-has-available', hasAvailable ? 'true' : 'false');
    });
}

function updateVariantTileAvailability() {
    var productJson = getProductJsonFromPage();
    if (!productJson || !productJson.variants || !productJson.variants.length) {
        return;
    }

    var $splitColorTiles = $('.variant-tiles[data-split-type="color"]');
    var $splitSizeTiles = $('.variant-tiles[data-split-type="size"]');
    var isSplitMode = $splitColorTiles.length > 0 && $splitSizeTiles.length > 0;

    if (isSplitMode) {
        updateSplitVariantTileAvailability(productJson, $splitColorTiles, $splitSizeTiles);
        return;
    }

    var selectedByIndex = {};
    $('.variant-tiles').each(function() {
        var $selected = $(this).find('.variant-tile-selected');
        if ($selected.length) {
            var idx = parseInt($selected.data('option-index'), 10);
            selectedByIndex[idx] = getTileOptionValue($selected);
        }
    });

    var sizeOptionIndex = getSizeOptionIndex(productJson);
    var selectedSize = sizeOptionIndex !== null ? selectedByIndex[sizeOptionIndex] : null;

    $('.variant-tile').each(function() {
        var $tile = $(this);
        var $tilesContainer = $tile.closest('.variant-tiles');
        var optionIndex = parseInt($tile.data('option-index'), 10);
        var optionValue = getTileOptionValue($tile);
        if (isNaN(optionIndex) || optionValue === null) {
            return;
        }

        var hasAvailable = false;
        for (var i = 0; i < productJson.variants.length; i++) {
            var variant = productJson.variants[i];
            if (!optionValuesMatch(variant.options[optionIndex], optionValue)) {
                continue;
            }

            if (isSizeOptionTiles($tilesContainer)) {
                if (variant.available) {
                    hasAvailable = true;
                    break;
                }
                continue;
            }

            if (isColourOptionTiles($tilesContainer) && sizeOptionIndex !== null && selectedSize) {
                if (!optionValuesMatch(variant.options[sizeOptionIndex], selectedSize)) {
                    continue;
                }
                if (variant.available) {
                    hasAvailable = true;
                    break;
                }
                continue;
            }

            var matchesSelection = true;
            for (var selIdx in selectedByIndex) {
                if (!selectedByIndex.hasOwnProperty(selIdx)) {
                    continue;
                }
                var idxNum = parseInt(selIdx, 10);
                if (idxNum === optionIndex) {
                    continue;
                }
                if (!optionValuesMatch(variant.options[idxNum], selectedByIndex[selIdx])) {
                    matchesSelection = false;
                    break;
                }
            }

            if (matchesSelection && variant.available) {
                hasAvailable = true;
                break;
            }
        }

        $tile.toggleClass('variant-tile-out-of-stock', !hasAvailable);
        $tile.attr('data-has-available', hasAvailable ? 'true' : 'false');
    });
}

// New function to handle variant selection from tiles
function updateVariantFromTiles() {
    updateVariantTileAvailability();
    // Check if we're using split options (Color - Size)
    var $splitColorTiles = $('.variant-tiles[data-split-type="color"]');
    var $splitSizeTiles = $('.variant-tiles[data-split-type="size"]');
    var isSplitMode = $splitColorTiles.length > 0 && $splitSizeTiles.length > 0;
    
    var selectedValues = [];
    var optionNames = [];
    
    if (isSplitMode) {
        // Handle split options
        var $selectedColor = $splitColorTiles.find('.variant-tile-selected');
        var $selectedSize = $splitSizeTiles.find('.variant-tile-selected');
        
        if ($selectedColor.length && $selectedSize.length) {
            var colorValue = getTileOptionValue($selectedColor);
            var sizeValue = getTileOptionValue($selectedSize);
            var combinedValue = colorValue + ' - ' + sizeValue;
            selectedValues[0] = combinedValue;
            optionNames[0] = 'Size'; // The actual option name in Shopify
        }
    } else {
        // Normal option handling
        $('.variant-tiles').each(function() {
            var $tilesContainer = $(this);
            var $selectedTile = $tilesContainer.find('.variant-tile-selected');
            if ($selectedTile.length) {
                var optionIndex = parseInt($selectedTile.data('option-index'));
                var optionValue = getTileOptionValue($selectedTile);
                var optionName = $tilesContainer.data('option-name');
                
                // Ensure array is large enough
                while (selectedValues.length <= optionIndex) {
                    selectedValues.push(null);
                    optionNames.push(null);
                }
                selectedValues[optionIndex] = optionValue;
                optionNames[optionIndex] = optionName;
            }
        });
    }
    
    // Find matching variant
    var $mainProductSelect = $("#ProductSelect-product-template, #ProductSelect-indiv-product");
    if (!$mainProductSelect.length) {
        console.log("updateVariantFromTiles(): Product select not found.");
        return;
    }
    
    var productJson = getProductJsonFromPage();
    
    var matchingVariant = null;
    var markSoldOut = false;
    var price = "N/A";
    
    if (productJson && productJson.variants) {
        // Find variant that matches all selected option values
        variantLoop: for (var i = 0; i < productJson.variants.length; i++) {
            var variant = productJson.variants[i];
            var matches = true;
            
            // Handle split options (combined value like "Navy - Small")
            if (isSplitMode && selectedValues.length > 0 && selectedValues[0]) {
                // Compare the combined value with variant's first option
                if (!optionValuesMatch(variant.options[0], selectedValues[0])) {
                    matches = false;
                }
            } else {
                // Normal option matching
                for (var j = 0; j < selectedValues.length; j++) {
                    if (selectedValues[j] !== null && !optionValuesMatch(variant.options[j], selectedValues[j])) {
                        matches = false;
                        break;
                    }
                }
            }
            
            if (matches) {
                matchingVariant = variant;
                markSoldOut = !variant.available;
                price = variant.price;
                break variantLoop;
            }
        }
    }
    
    // Fallback: try to find variant using the hidden selects
    if (!matchingVariant) {
        var selectedOptions = [];
        $('.variant-select-hidden').each(function() {
            var val = $(this).val();
            if (val) {
                selectedOptions.push(val);
            }
        });
        
        // Try to find variant by matching option values in the select
        $mainProductSelect.find('option').each(function() {
            var $option = $(this);
            var dataName = $option.data('name');
            if (dataName) {
                var nameParts = String(dataName).split(' / ');
                var allMatch = true;
                for (var k = 0; k < selectedOptions.length; k++) {
                    var found = false;
                    for (var m = 0; m < nameParts.length; m++) {
                        if (nameParts[m].trim() === selectedOptions[k]) {
                            found = true;
                            break;
                        }
                    }
                    if (!found) {
                        allMatch = false;
                        break;
                    }
                }
                if (allMatch) {
                    matchingVariant = {
                        id: $option.val(),
                        available: !$option.is(':disabled') && !$option.text().includes('Sold Out'),
                        price: $option.data('price') || price
                    };
                    markSoldOut = !matchingVariant.available;
                    price = matchingVariant.price || price;
                    return false; // break
                }
            }
        });
    }
    
    // Update the main product select
    if (matchingVariant && matchingVariant.id) {
        var $option = $mainProductSelect.find('option[value="' + matchingVariant.id + '"]');
        if ($option.length && $option.is(':disabled')) {
            $option.prop('disabled', false);
            $mainProductSelect.val(matchingVariant.id);
            $option.prop('disabled', true);
        } else {
            $mainProductSelect.val(matchingVariant.id);
        }
        $mainProductSelect.trigger('change');
    } else if (selectedValues.length > 0 && selectedValues.some(function(v) { return v !== null; })) {
        // No matching variant found but options are selected - this means the combination doesn't exist or is all out of stock
        markSoldOut = true;
    }
    
    // Wait a bit for theme's update_variant to run, then check actual variant state
    setTimeout(function() {
        // Check the actual selected variant from the main select
        var $selectedOption = $mainProductSelect.find('option:selected');
        var isActuallySoldOut = false;
        
        if (matchingVariant && !matchingVariant.available) {
            isActuallySoldOut = true;
        } else if ($selectedOption.length) {
            isActuallySoldOut = $selectedOption.is(':disabled') || $selectedOption.text().includes('Sold Out') || $selectedOption.text().includes('sold out');
        } else {
            isActuallySoldOut = true;
        }
        
        if (!matchingVariant && selectedValues.length > 0) {
            isActuallySoldOut = true;
        }
        
        // Disable add to cart button if variant is out of stock or doesn't exist
        var $addToCartBtn = $('#purchase');
        if (isActuallySoldOut) {
            $addToCartBtn.prop('disabled', true).addClass('disabled');
        } else {
            $addToCartBtn.prop('disabled', false).removeClass('disabled');
        }
        
    }, 100);
}

function updateSoldOutPrice() {
    // Created: 8/10/20
    // Updated: 2025-05-13 (Handles varying order in data-name for Color/Size)

    // Desc: Runs on prod page load/variant to check if selected combo is sold out.
    // - If 'productVariantDebug' in localStorage is 'true', a table of all variants and their status is shown.
    // - If the selected combo is sold out:
    //   - 'SOLD OUT' is prefixed to the price.
    //   - A stock notify button is added.

    // --- Debug Table Logic ---
    const isDebugMode = localStorage.getItem('productVariantDebug') === 'true';
    const debugTableContainerId = 'variant-debug-table-container';
    $('#' + debugTableContainerId).remove();

    if (isDebugMode) {
        console.log("updateSoldOutPrice() - DEBUG MODE ACTIVE (localStorage)");
        const $mainProductSelectForDebug = $("#ProductSelect-product-template");
        if ($mainProductSelectForDebug.length) {
            let debugTableHTML = `
                <div id="${debugTableContainerId}" style="margin-top: 20px; border: 1px solid #ccc; padding: 10px; background-color: #f9f9f9; font-family: monospace; color: #333;">
                    <h3 style="margin-top:0; margin-bottom: 10px; color: #111;">Variant Debug Information</h3>
                    <p style="font-size: 11px; margin-bottom: 15px;">To disable, type in console: <code style="background-color: #e0e0e0; padding: 2px 4px; border-radius: 3px;">localStorage.removeItem('productVariantDebug');</code> and reload/re-trigger.</p>
                    <table border="1" style="width:100%; border-collapse: collapse; font-size: 12px; table-layout: fixed;">
                        <thead style="background-color: #eee;">
                            <tr>
                                <th style="padding: 5px; width: 25%;">Original Text</th>
                                <th style="padding: 5px; width: 20%;">Data-Name</th>
                                <th style="padding: 5px; width: 10%;">Parsed Size (Debug)</th>
                                <th style="padding: 5px; width: 15%;">Parsed Colour (Debug)</th>
                                <th style="padding: 5px; width: 8%;">Price</th>
                                <th style="padding: 5px; width: 7%;">Disabled?</th>
                                <th style="padding: 5px; width: 8%;">"Sold Out" Text?</th>
                                <th style="padding: 5px; width: 12%;">Calculated Availability</th>
                            </tr>
                        </thead>
                        <tbody>
            `;
            $mainProductSelectForDebug.find("option").each(function() {
                const $option = $(this);
                const optionText = $option.text().trim();
                const dataNameRaw = $option.data("name");
                const dataName = (dataNameRaw !== undefined && dataNameRaw !== null) ? String(dataNameRaw) : "N/A";
                const price = $option.data("price") || "N/A";
                const isDisabled = $option.is(':disabled');
                const hasSoldOutText = optionText.includes(" - Sold Out");
                const isAvailable = !isDisabled && !hasSoldOutText;
                let parsedDebugSize = "N/A"; // For debug table display only
                let parsedDebugColour = "N/A"; // For debug table display only
                if (dataName !== "N/A") {
                    const parts = dataName.split(" / ");
                    // This parsing is a simple split for the debug table; it might not always
                    // correctly label "Size" vs "Color" if the order varies and isn't known.
                    // The core logic uses currentSize/currentColour from selectors.
                    parsedDebugSize = parts[0] ? parts[0].trim() : "N/A";
                    if (parts.length > 1) {
                        parsedDebugColour = parts.slice(1).join(" / ").trim();
                    }
                }
                debugTableHTML += `
                    <tr style="background-color: ${isAvailable ? '#e6ffe6' : '#ffe6e6'};">
                        <td style="padding: 4px; word-wrap: break-word;">${optionText}</td>
                        <td style="padding: 4px; word-wrap: break-word;">${dataName}</td>
                        <td style="padding: 4px; word-wrap: break-word;">${parsedDebugSize}</td>
                        <td style="padding: 4px; word-wrap: break-word;">${parsedDebugColour}</td>
                        <td style="padding: 4px;">${price}</td>
                        <td style="padding: 4px; text-align: center;">${isDisabled ? 'Yes' : 'No'}</td>
                        <td style="padding: 4px; text-align: center;">${hasSoldOutText ? 'Yes' : 'No'}</td>
                        <td style="padding: 4px; font-weight: bold; color: ${isAvailable ? 'green' : 'red'}; text-align: center;">${isAvailable ? 'Available' : 'SOLD OUT'}</td>
                    </tr>
                `;
            });
            debugTableHTML += '</tbody></table></div>';
            if ($(".product-form").length) {
                 $(".product-form").first().prepend(debugTableHTML);
            } else if ($("#purchase").length) {
                 $("#purchase").parent().prepend(debugTableHTML);
            } else {
                $('body').prepend(debugTableHTML);
            }
        } else {
            console.log("updateSoldOutPrice() - DEBUG: #ProductSelect-product-template not found for debug table.");
        }
    }

    const $priceField = $("#price-field");

    var currentSize = "";
    var currentColour = "";
    // Check both capitalized and lowercase class names for size selector
    var $sizeSelectedOption = $(".selector-option-Size option:selected, .selector-option-size option:selected").first();
    if ($sizeSelectedOption.length && $sizeSelectedOption.val() && $sizeSelectedOption.val().toLowerCase() !== "select size" && $sizeSelectedOption.val() !== "Default Title") {
        currentSize = $sizeSelectedOption.val();
    }
    // Check both capitalized and lowercase class names for color selector
    var $colorSelectedOption = $(".selector-option-Color option:selected, .selector-option-color option:selected").first();
    if ($colorSelectedOption.length && $colorSelectedOption.val() && $colorSelectedOption.val().toLowerCase() !== "select color" && $colorSelectedOption.val() !== "Default Title") {
        currentColour = $colorSelectedOption.val();
    } else {
        var $colourSelectedOption = $(".selector-option-Colour option:selected, .selector-option-colour option:selected").first();
        if ($colourSelectedOption.length && $colourSelectedOption.val() && $colourSelectedOption.val().toLowerCase() !== "select colour" && $colourSelectedOption.val() !== "Default Title") {
            currentColour = $colourSelectedOption.val();
        }
    }
    console.log("updateSoldOutPrice() initial selections: Size='" + currentSize + "', Colour='" + currentColour + "'");

    var markSoldOut = false;
    var price = "N/A";
    var $mainProductSelect = $("#ProductSelect-product-template");
    let finalDisplaySize = currentSize;
    let finalDisplayColour = currentColour;

    if ($mainProductSelect.length) {
        let $chosenOption = null;

        // Case 1: Both Size and Colour are selected by the user
        if (currentSize && currentColour) {
            // Construct potential data-name strings in both orders
            const targetDataNameOrder1 = currentSize + " / " + currentColour; // e.g., "Small (46) / Khaki"
            const targetDataNameOrder2 = currentColour + " / " + currentSize; // e.g., "Khaki / Small (46)"

            console.log("updateSoldOutPrice() [Exact Match]: Trying data-name: '" + targetDataNameOrder1 + "'");
            $chosenOption = $mainProductSelect.find("option[data-name='" + targetDataNameOrder1 + "']").first();

            if (!$chosenOption.length) { // If first order didn't match, try the second order
                console.log("updateSoldOutPrice() [Exact Match]: Variant '" + targetDataNameOrder1 + "' not found. Trying alternate order: '" + targetDataNameOrder2 + "'");
                $chosenOption = $mainProductSelect.find("option[data-name='" + targetDataNameOrder2 + "']").first();
            }

            if (!$chosenOption.length) { // If neither order matched
                markSoldOut = true;
                console.log("updateSoldOutPrice() [Exact Match]: Variant matching EITHER '" + targetDataNameOrder1 + "' OR '" + targetDataNameOrder2 + "' not found in Shopify select. Marked SOLD OUT.");
            } else {
                console.log("updateSoldOutPrice() [Exact Match]: Found variant with data-name: '" + $chosenOption.data("name") + "'");
            }
        }
        // Case 2: Only Colour is selected, Size is not
        else if (currentColour && !currentSize) {
            finalDisplaySize = "Any"; // For messaging
            // This search is broad, might need refinement if color names are substrings of others.
            // It looks for the color string anywhere in the data-name.
            const $allColorOptions = $mainProductSelect.find("option[data-name*='" + currentColour + "']");
            $chosenOption = $allColorOptions.filter(function() {
                return !$(this).text().trim().includes(" - Sold Out") && !$(this).is(':disabled');
            }).first(); // Get the first available one

            if (!$chosenOption.length && $allColorOptions.length) {
                $chosenOption = $allColorOptions.first();
                console.log("updateSoldOutPrice() [Color Only]: No _available_ options for color '" + currentColour + "'. Using first found (which is likely sold out/disabled).");
            } else if (!$chosenOption.length) {
                markSoldOut = true;
                console.log("updateSoldOutPrice() [Color Only]: No variants found at all containing color '" + currentColour + "'. Marked SOLD OUT.");
            }
        }
        // Case 3: Only Size is selected, Colour is not (or product has no color option)
        else if (currentSize && !currentColour) {
            finalDisplayColour = "N/A";
            console.log("updateSoldOutPrice() [Size Only]: Attempting to find exact data-name match for size: '" + currentSize + "'");
            $chosenOption = $mainProductSelect.find("option[data-name='" + currentSize + "']").first(); // For size-only products

            if (!$chosenOption.length) {
                console.log("updateSoldOutPrice() [Size Only]: Exact data-name match failed for '" + currentSize + "'. Fallback: Trying prefix search data-name^='" + currentSize + " /'");
                const $allSizeOptions = $mainProductSelect.find("option[data-name^='" + currentSize + " /']"); // For "Size / Color" products
                $chosenOption = $allSizeOptions.filter(function() {
                    return !$(this).text().trim().includes(" - Sold Out") && !$(this).is(':disabled');
                }).first();

                if (!$chosenOption.length && $allSizeOptions.length) {
                    $chosenOption = $allSizeOptions.first();
                    console.log("updateSoldOutPrice() [Size Only - Prefix Fallback]: No _available_ options for size prefix '" + currentSize + " /'. Using first found.");
                } else if (!$chosenOption.length) {
                     // One more attempt: if data-name ends with " / Size" (like "Color / Size")
                    console.log("updateSoldOutPrice() [Size Only - Prefix Fallback]: Trying suffix search data-name$=' / " + currentSize + "']");
                    const $allSizeOptionsSuffix = $mainProductSelect.find("option[data-name$=' / " + currentSize + "']");
                    $chosenOption = $allSizeOptionsSuffix.filter(function() {
                        return !$(this).text().trim().includes(" - Sold Out") && !$(this).is(':disabled');
                    }).first();
                     if (!$chosenOption.length && $allSizeOptionsSuffix.length) {
                        $chosenOption = $allSizeOptionsSuffix.first();
                        console.log("updateSoldOutPrice() [Size Only - Suffix Fallback]: No _available_ options for size suffix ' / " + currentSize + "'. Using first found.");
                    } else if (!$chosenOption.length) {
                        markSoldOut = true;
                        console.log("updateSoldOutPrice() [Size Only - All Fallbacks Failed]: No variants found for size '" + currentSize + "'. Marked SOLD OUT.");
                    }
                }
            } else {
                console.log("updateSoldOutPrice() [Size Only]: Found exact data-name match for '" + currentSize + "'.");
            }
        }
        // Case 4: Neither Size nor Colour is selected by the user
        else {
            console.log("updateSoldOutPrice() [No User Selection]: Checking Shopify select's default/current option.");
            $chosenOption = $mainProductSelect.find("option:selected").first();
            var dataNameVal = $chosenOption.length ? $chosenOption.data("name") : null;
            if (dataNameVal !== undefined && dataNameVal !== null) {
                const nameParts = String(dataNameVal).split(" / ");
                finalDisplaySize = nameParts[0] ? nameParts[0].trim() : (currentSize || "Selected");
                if (nameParts.length > 1) {
                    finalDisplayColour = nameParts.slice(1).join(" / ").trim();
                } else {
                    finalDisplayColour = (currentColour || "Variant"); // Could be a size-only product
                }
            } else if ($chosenOption.length) {
                // No data-name but option exists - likely a simple product without variants
                // Don't mark as sold out here; let the analysis section below check availability
                console.log("updateSoldOutPrice() [No User Selection]: Option found but no data-name. Will check availability in analysis section.");
                finalDisplaySize = "Default";
                finalDisplayColour = "N/A";
            } else {
                markSoldOut = true;
                console.log("updateSoldOutPrice() [No User Selection]: No valid default option in Shopify select. Marked SOLD OUT.");
            }
        }

        // --- Analyze the $chosenOption (if one was determined by the logic above) ---
        if ($chosenOption && $chosenOption.length) {
            const optionText = $chosenOption.text().trim();
            price = $chosenOption.data("price") || "N/A";
            if (optionText.includes(" - Sold Out") || $chosenOption.is(':disabled')) {
                markSoldOut = true;
                console.log("updateSoldOutPrice() [Option Analysis]: Variant '" + ($chosenOption.data("name") || optionText) + "' is SOLD OUT or disabled.");
            } else {
                markSoldOut = false;
                console.log("updateSoldOutPrice() [Option Analysis]: Variant '" + ($chosenOption.data("name") || optionText) + "' is AVAILABLE.");
            }
            // Update display names from the actual chosen Shopify option if they were initially "Any" or "N/A"
            // This part is tricky if data-name order varies. User-selected currentSize/currentColour are preferred.
            var chosenDataName = $chosenOption.data("name");
            if ((finalDisplaySize === "Any" || !finalDisplaySize) && chosenDataName !== undefined && chosenDataName !== null) {
                // Attempt to infer, but this is non-trivial if order varies and not all parts are present
                // For now, if currentSize was set, it remains. If not, this is a best guess.
                 const nameParts = String(chosenDataName).split(" / ");
                 // Heuristic: if currentSize was not set by user, and data-name has parts, assume one is size.
                 // This won't be perfect for all data-name structures.
                 if (!currentSize) finalDisplaySize = nameParts[0].trim(); // Default to first part if currentSize was empty
            }
            if ((finalDisplayColour === "Any" || finalDisplayColour === "N/A" || !finalDisplayColour) && chosenDataName !== undefined && chosenDataName !== null) {
                const nameParts = String(chosenDataName).split(" / ");
                if (!currentColour) { // Only infer if user didn't select a color
                    if (nameParts.length > 1) {
                        finalDisplayColour = nameParts.slice(1).join(" / ").trim(); // Default to second part if currentColour was empty
                    } else if (!nameParts[0].includes(currentSize)) { // If single part data-name and it's not the size
                        finalDisplayColour = nameParts[0].trim();
                    } else {
                        finalDisplayColour = "N/A";
                    }
                }
            }

        } else if (!markSoldOut) {
            markSoldOut = true;
            console.log("updateSoldOutPrice(): No specific matching variant found in Shopify select. Defaulting to SOLD OUT.");
        }

        // --- Update the Price Field and Add 'Notify Me' Button based on markSoldOut status ---
        if (markSoldOut) {
            let logColour = (finalDisplayColour === "N/A" || !finalDisplayColour) ? "" : finalDisplayColour + " / ";
            console.log("updateSoldOutPrice() - CONCLUSION: Marking (" + logColour + (finalDisplaySize || "N/A") + ") as SOLD OUT! Price: " + price);
            $priceField.html("SOLD OUT - (" + price + ")");
        } else {
            let conclusionColour = (finalDisplayColour === "N/A" || !finalDisplayColour) ? "" : finalDisplayColour + " - ";
            console.log("updateSoldOutPrice() - CONCLUSION: Option (" + conclusionColour + (finalDisplaySize || "N/A") + ") NOT sold out. Price: " + price);
            if (price === "N/A") {
                $priceField.html('Price unavailable');
            } else {
                $priceField.html(price);
            }
        }
    } else {
        console.log("updateSoldOutPrice(): Main product select '#ProductSelect-product-template' not found. Nothing to do.");
        $priceField.html("Product information unavailable.");
    }
}




function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // Escapes special characters
}


function isFullMatch(stringToMatch, thePattern) {
    var escapedPattern = thePattern.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // Escape special regex chars
    // Ensure thePattern matches as a whole word directly adjacent to spaces, slashes, or dashes
    var re = new RegExp("(^|\\s|/|-)"+escapedPattern+"(\\s|/|-|$)", "i");
    return re.test(stringToMatch.trim()) && !new RegExp(`(?:/|-)\\s*\\w+\\s+${escapedPattern}`, "i").test(stringToMatch.trim());
}


function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
}


function markSoldOutVariantsSelect(){
  	// Created: 8/10/20 : AJ
    // Updated: 13/10/20
	// Adds a class to the variants selector to mark sold out items differently so they can be shaded in another style
  	
  	console.log("Iterating product options looking for sold out...");
  	$("#ProductSelect-product-template option").each(function(i){
      var currentLabel=$(this).text().trim();
      var currentNameRaw = $(this).data("name");
      // Safety check: ensure data-name exists and is a string before trimming
      if (currentNameRaw === undefined || currentNameRaw === null) {
        console.log("Skipping option with no data-name attribute");
        return; // Skip this option, continue to next
      }
      var currentName = String(currentNameRaw).trim();
      
      // if we have colours explode and get just the size
      if (currentName.includes(" / ")){
        currentName=currentName.split(" / ");
        currentName=currentName[1];
      }
      
      console.log(currentLabel);
      
      if (currentLabel.includes(" - Sold Out")){
        // iterate through envy themes alternative select variants
      	$(".sod_list span").each(function(i){
          var currentEnvyLabel=$(this).text().trim();
          console.log("checking envy select list for same name as this label ("+currentName+"), we found: "+currentEnvyLabel);
          
          if (currentEnvyLabel.includes(currentName)){
            //$(this).css('opacity', '0.4');
            //$(this).append(" - SOLD OUT");
          }else{
            console.log("not included");
          }
        });
      }
    });
	
}



function create_drawer(side, panel, menu, hidden_menu, overlay) {
    var padding = MOBILE_DRAWER_SIZE;
    if (side === 'right' && document.body.clientWidth >= MOBILE_WIDTH_MAX) {
        padding = DESKTOP_DRAWER_SIZE;
    }

    var slideout = new Slideout({
        'panel': panel,
        'menu': menu,
        'padding': padding,
        'tolerance': 70,
        'side': side,
        'touch': false
    });
    var dir = (side === 'right') ? -1 : 1;
    window.slideouts[side] = slideout;
    menu.classList.add('slideout-panel-hidden');

    var $overlay = $(overlay);
    overlay.addEventListener('click', slideout.close.bind(slideout));

    // Handle slide to close
    var touch_start = null;
    overlay.addEventListener('touchstart', function (event) {
        if (!slideout.isOpen()) {
            return;
        }
        event.preventDefault();
        touch_start = event.touches[0].pageX;
    });
    overlay.addEventListener('touchmove', function (event) {
        if (!slideout.isOpen()) {
            return;
        }
        var offset = touch_start - event.touches[0].pageX;
        var translate = (dir * padding) - offset;
        if (Math.abs(translate) > padding) {
            translate = (dir * padding);
        }
        panel.style.webkitTransform ='translateX(' + translate + 'px)';
        panel.style.transform ='translateX(' + translate + 'px)';
    });
    overlay.addEventListener('touchend', function (event) {
        if (!slideout.isOpen()) {
            return;
        }
        var offset = touch_start - event.changedTouches[0].pageX;
        if (offset === 0 || Math.abs(offset) > 70) {
            slideout.close(slideout);
        } else {
            panel.style.webkitTransform = 'translateX(' + (dir * padding) + 'px)';
            panel.style.transform = 'translateX(' + (dir * padding) + 'px)';
        }
    });

    slideout.on('beforeopen', function() {
        menu.classList.remove('slideout-panel-hidden');
        hidden_menu.classList.add('slideout-panel-hidden');
        $overlay.fadeIn();
        // document.body.style.overflowY = 'hidden';
        var marginTop = (-document.body.scrollTop) + 'px';
        panel.style.position = 'fixed';
        panel.style.marginTop = marginTop;
    });

    slideout.on('beforeclose', function () {
        $overlay.fadeOut();
        var scrollTop = -parseInt(panel.style.marginTop);
        panel.style.position = '';
        panel.style.marginTop = '';
        document.body.scrollTop = scrollTop;
    });

    slideout.on('close', function() {
        menu.classList.add('slideout-panel-hidden');
        console.log("Closing - in function");
        $('.navigation-button').css('visibility', 'visible');
    });
    slideout.on('translate', function(translated) {
        var hidden = false;
        if (translated === 0) {
            hidden = true;
        } else if (side === 'left') {
            hidden = translated <= 0;
        } else if (side === 'right') {
            hidden = translated >= 0;
        }
        menu.classList.toggle('slideout-panel-hidden', hidden);
        hidden_menu.classList.toggle('slideout-panel-hidden', !hidden);
    });

    return slideout;
}



function load_menu_drawer() {
    var main_body = document.querySelector('#main-body');
    var left_menu = document.querySelector('#menu');
    var right_menu = document.querySelector('#cartSlideoutWrapper');
    var overlay = document.querySelector('#slideout-overlay');

    /* Mobile Menu */

    /* Move mobile menu out of section to document body because the slideout
       needs to put it to the sidebar, but it can't be in the body from the beginning
       because it needs section config */
    document.body.appendChild(left_menu);

    var slideoutLeft = create_drawer('left', main_body, left_menu, right_menu, overlay);

    $('.slide-menu-mobile').on('click', function() {
        slideoutLeft.toggle();
        console.log("Menu clicked");
    });

    $('.mobile-menu-close').on('click', function () {
        slideoutLeft.close();
        console.log("Menu closed");
    });

    // Disable mobile drawer on desktop
    if (document.body.clientWidth >= MOBILE_WIDTH_MAX) {
        slideoutLeft._touch = false;
    }

    // Add events for sidebar manipulation from outside
    $(left_menu)
        .on('mobile:toggle', slideoutLeft.toggle.bind(slideoutLeft))
        .on('mobile:open', slideoutLeft.open.bind(slideoutLeft))
        .on('mobile:close', slideoutLeft.close.bind(slideoutLeft));

    /* Cart */
    var slideoutRight = create_drawer('right', main_body, right_menu, left_menu, overlay);

    // Toggle button
    $('.slide-menu-cart').on('click', function (e) {
        slideoutRight.toggle();
        // prevent non-ajax basket
        e.preventDefault();
        return false;
    });

    $('.cart-menu-close').on('click', function (e) {
        slideoutRight.close();
    });

    // Add events for sidebar manipulation from outside
    $(right_menu)
        .on('cart:toggle', slideoutRight.toggle.bind(slideoutRight))
        .on('cart:open', slideoutRight.open.bind(slideoutRight))
        .on('cart:close', slideoutRight.close.bind(slideoutRight));
  
}

$(document).ready(load_menu_drawer);

document.addEventListener('shopify:section:load', function (event) {
    if (event.detail.sectionId === 'header') {
        load_menu_drawer();
    } else if (event.detail.sectionId === 'footer') {
        // Shopify doesn't correctly handle scrolling to footer on section change because the section
        // has zero height when it's scrolled to but when it loads it gets out of visible area
        setTimeout(function () {
            // Scroll to the footer element after loading
            document.documentElement.scrollTop = document.body.scrollTop = document.body.clientHeight;
        }, 0);
    }
});


/* PS theme imported content */
$(document).ready(function() {

  // ?
  $('#searchform select, #searchform input[type="checkbox"], #searchform input[type="radio"]').change(function() {
    $(this).closest("form").submit();
  });
  
  // catch open action  of slide out menu
  $('.navigation-button').click(function() {
      console.log("opening");
      $('body').toggleClass('no-scroll');       		
      $(this).toggleClass('visible');  
      $('.navigation-overlay').toggleClass('visible');  
      $('.navigation-button').css('visibility', 'hidden');
         		
  });

  // catch close action of slide out menu
  /*
  $('.sidr-close-icon, #slideout-overlay').click(function () {
      console.log("closing");
      $('.navigation-button').show();
      $('body').toggleClass('no-scroll');       		
      $('.navigation-button').toggleClass('visible');  
      $('.search-overlay').toggleClass('visible');
      $(".search-overlay input[type='text']").focus();
    
  });
  */

  $(document).on('click','#slideout-overlay', function(event){
    console.log("ha");
   });
  
});







(function(d){d.Observe={}})(jQuery);
(function(d,q){var r=function(e,f){f||(f=e,e=window.document);var m=[];d(f).each(function(){for(var l=[],g=d(this),h=g.parent();h.length&&!g.is(e);h=h.parent()){var f=g.get(0).tagName.toLowerCase();l.push(f+":eq("+h.children(f).index(g)+")");g=h}(h.length||g.is(e))&&m.push("> "+l.reverse().join(" > "))});return m.join(", ")};q.path={get:r,capture:function(e,f){f||(f=e,e=window.document);var m=[];d(f).each(function(){var l=-1,g=this;if(this instanceof Text)for(var g=this.parentNode,h=g.childNodes,
f=0;f<h.length;f++)if(h[f]===this){l=f;break}var k=r(e,g),n=d(e).is(g);m.push(function(e){e=n?e:d(e).find(k);return-1===l?e:e.contents()[l]})});return function(e){e=e||window.document;return m.reduce(function(d,f){return d.add(f(e))},d([]))}}}})(jQuery,jQuery.Observe);(function(d,q){var r=function(e){this.original=d(e);this.root=this.original.clone(!1,!0)};r.prototype.find=function(d){return q.path.capture(this.original,d)(this.root)};q.Branch=r})(jQuery,jQuery.Observe);
(function(d,q){var r=function(a,b){var c={};a.forEach(function(a){(a=b(a))&&(c[a[0]]=a[1])});return c},e=r("childList attributes characterData subtree attributeOldValue characterDataOldValue attributeFilter".split(" "),function(a){return[a.toLowerCase(),a]}),f=r(Object.keys(e),function(a){if("attributefilter"!==a)return[e[a],!0]}),m=r(["added","removed"],function(a){return[a.toLowerCase(),a]}),l=d([]),g=function(a){if("object"===typeof a)return a;a=a.split(/\s+/);var b={};a.forEach(function(a){a=
a.toLowerCase();if(!e[a]&&!m[a])throw Error("Unknown option "+a);b[e[a]||m[a]]=!0});return b},h=function(a){return"["+Object.keys(a).sort().reduce(function(b,c){var d=a[c]&&"object"===typeof a[c]?h(a[c]):a[c];return b+"["+JSON.stringify(c)+":"+d+"]"},"")+"]"},t=window.MutationObserver||window.WebKitMutationObserver,k=function(a,b,c,s){this._originalOptions=d.extend({},b);b=d.extend({},b);this.attributeFilter=b.attributeFilter;delete b.attributeFilter;c&&(b.subtree=!0);b.childList&&(b.added=!0,b.removed=
!0);if(b.added||b.removed)b.childList=!0;this.target=d(a);this.options=b;this.selector=c;this.handler=s};k.prototype.is=function(a,b,c){return h(this._originalOptions)===h(a)&&this.selector===b&&this.handler===c};k.prototype.match=function(a){var b=this.options,c=a.type;if(!this.options[c])return l;if(this.selector)switch(c){case "attributes":if(!this._matchAttributeFilter(a))break;case "characterData":return this._matchAttributesAndCharacterData(a);case "childList":if(a.addedNodes&&a.addedNodes.length&&
b.added&&(c=this._matchAddedNodes(a),c.length))return c;if(a.removedNodes&&a.removedNodes.length&&b.removed)return this._matchRemovedNodes(a)}else{var s=a.target instanceof Text?d(a.target).parent():d(a.target);if(!b.subtree&&s.get(0)!==this.target.get(0))return l;switch(c){case "attributes":if(!this._matchAttributeFilter(a))break;case "characterData":return this.target;case "childList":if(a.addedNodes&&a.addedNodes.length&&b.added||a.removedNodes&&a.removedNodes.length&&b.removed)return this.target}}return l};
k.prototype._matchAttributesAndCharacterData=function(a){return this._matchSelector(this.target,[a.target])};k.prototype._matchAddedNodes=function(a){return this._matchSelector(this.target,a.addedNodes)};k.prototype._matchRemovedNodes=function(a){var b=new q.Branch(this.target),c=Array.prototype.slice.call(a.removedNodes).map(function(a){return a.cloneNode(!0)});a.previousSibling?b.find(a.previousSibling).after(c):a.nextSibling?b.find(a.nextSibling).before(c):(this.target===a.target?b.root:b.find(a.target)).empty().append(c);
return this._matchSelector(b.root,c).length?d(a.target):l};k.prototype._matchSelector=function(a,b){var c=a.find(this.selector);b=Array.prototype.slice.call(b);return c=c.filter(function(){var a=this;return b.some(function(b){return b instanceof Text?b.parentNode===a:b===a||d(b).has(a).length})})};k.prototype._matchAttributeFilter=function(a){return this.attributeFilter&&this.attributeFilter.length?0<=this.attributeFilter.indexOf(a.attributeName):!0};var n=function(a){this.patterns=[];this._target=
a;this._observer=null};n.prototype.observe=function(a,b,c){var d=this;this._observer?this._observer.disconnect():this._observer=new t(function(a){a.forEach(function(a){d.patterns.forEach(function(b){var c=b.match(a);c.length&&c.each(function(){b.handler.call(this,a)})})})});this.patterns.push(new k(this._target,a,b,c));this._observer.observe(this._target,this._collapseOptions())};n.prototype.disconnect=function(a,b,c){var d=this;this._observer&&(this.patterns.filter(function(d){return d.is(a,b,c)}).forEach(function(a){a=
d.patterns.indexOf(a);d.patterns.splice(a,1)}),this.patterns.length||this._observer.disconnect())};n.prototype.disconnectAll=function(){this._observer&&(this.patterns=[],this._observer.disconnect())};n.prototype.pause=function(){this._observer&&this._observer.disconnect()};n.prototype.resume=function(){this._observer&&this._observer.observe(this._target,this._collapseOptions())};n.prototype._collapseOptions=function(){var a={};this.patterns.forEach(function(b){var c=a.attributes&&a.attributeFilter;
if(!c&&a.attributes||!b.attributeFilter)c&&b.options.attributes&&!b.attributeFilter&&delete a.attributeFilter;else{var e={},f=[];(a.attributeFilter||[]).concat(b.attributeFilter).forEach(function(a){e[a]||(f.push(a),e[a]=1)});a.attributeFilter=f}d.extend(a,b.options)});Object.keys(m).forEach(function(b){delete a[m[b]]});return a};var p=function(a){this.patterns=[];this._paused=!1;this._target=a;this._events={};this._handler=this._handler.bind(this)};p.prototype.NS=".jQueryObserve";p.prototype.observe=
function(a,b,c){a=new k(this._target,a,b,c);d(this._target);a.options.childList&&(this._addEvent("DOMNodeInserted"),this._addEvent("DOMNodeRemoved"));a.options.attributes&&this._addEvent("DOMAttrModified");a.options.characterData&&this._addEvent("DOMCharacerDataModified");this.patterns.push(a)};p.prototype.disconnect=function(a,b,c){var e=d(this._target),f=this;this.patterns.filter(function(d){return d.is(a,b,c)}).forEach(function(a){a=f.patterns.indexOf(a);f.patterns.splice(a,1)});var g=this.patterns.reduce(function(a,
b){b.options.childList&&(a.DOMNodeInserted=!0,a.DOMNodeRemoved=!0);b.options.attributes&&(a.DOMAttrModified=!0);b.options.characterData&&(a.DOMCharacerDataModified=!0);return a},{});Object.keys(this._events).forEach(function(a){g[a]||(delete f._events[a],e.off(a+f.NS,f._handler))})};p.prototype.disconnectAll=function(){var a=d(this._target),b;for(b in this._events)a.off(b+this.NS,this._handler);this._events={};this.patterns=[]};p.prototype.pause=function(){this._paused=!0};p.prototype.resume=function(){this._paused=
!1};p.prototype._handler=function(a){if(!this._paused){var b={type:null,target:null,addedNodes:null,removedNodes:null,previousSibling:null,nextSibling:null,attributeName:null,attributeNamespace:null,oldValue:null};switch(a.type){case "DOMAttrModified":b.type="attributes";b.target=a.target;b.attributeName=a.attrName;b.oldValue=a.prevValue;break;case "DOMCharacerDataModified":b.type="characterData";b.target=d(a.target).parent().get(0);b.attributeName=a.attrName;b.oldValue=a.prevValue;break;case "DOMNodeInserted":b.type=
"childList";b.target=a.relatedNode;b.addedNodes=[a.target];b.removedNodes=[];break;case "DOMNodeRemoved":b.type="childList",b.target=a.relatedNode,b.addedNodes=[],b.removedNodes=[a.target]}for(a=0;a<this.patterns.length;a++){var c=this.patterns[a],e=c.match(b);e.length&&e.each(function(){c.handler.call(this,b)})}}};p.prototype._addEvent=function(a){this._events[a]||(d(this._target).on(a+this.NS,this._handler),this._events[a]=!0)};q.Pattern=k;q.MutationObserver=n;q.DOMEventObserver=p;d.fn.observe=
function(a,b,c){b?c||(c=b,b=null):(c=a,a=f);return this.each(function(){var e=d(this),f=e.data("observer");f||(f=t?new n(this):new p(this),e.data("observer",f));a=g(a);f.observe(a,b,c)})};d.fn.disconnect=function(a,b,c){a&&(b?c||(c=b,b=null):(c=a,a=f));return this.each(function(){var e=d(this),f=e.data("observer");f&&(a?(a=g(a),f.disconnect(a,b,c)):(f.disconnectAll(),e.removeData("observer")))})}})(jQuery,jQuery.Observe);

// Search overlay functionality
$(document).ready(function() {
    var searchTimeout;
    var currentHighlighted = -1;
    
    // Search icon click handler
    $('.search-icon-wrapper').on('click', function() {
        openSearchOverlay();
    });
    
    
    // Close with Escape key
    $(document).on('keydown', function(e) {
        if (e.key === 'Escape') {
            closeSearchOverlay();
        }
    });
    
    // Search input functionality
    $('#search-input').on('input', function() {
        var query = $(this).val().trim();
        
        clearTimeout(searchTimeout);
        
        if (query.length < 2) {
            $('#search-suggestions').hide();
            return;
        }
        
        // Debounce search requests
        searchTimeout = setTimeout(function() {
            searchProducts(query);
        }, 300);
    });
    
    // Handle keyboard navigation
    $('#search-input').on('keydown', function(e) {
        var $suggestionItems = $('#search-suggestions .search-suggestion-item');
        
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            currentHighlighted = Math.min(currentHighlighted + 1, $suggestionItems.length - 1);
            updateHighlight($suggestionItems);
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            currentHighlighted = Math.max(currentHighlighted - 1, -1);
            updateHighlight($suggestionItems);
        } else if (e.key === 'Enter') {
            e.preventDefault();
            if (currentHighlighted >= 0 && $suggestionItems.eq(currentHighlighted).length) {
                var productUrl = $suggestionItems.eq(currentHighlighted).data('url');
                if (productUrl) {
                    window.location.href = productUrl;
                }
            } else {
                performSearch($(this).val());
            }
        }
    });
    
    // Suggestion item click handler - open product page directly
    $(document).on('click', '.search-suggestion-item', function() {
        var productUrl = $(this).data('url');
        if (productUrl) {
            window.location.href = productUrl;
        }
    });
    
    // Search icon click handler
    $('#search-submit-icon').on('click', function() {
        var query = $('#search-input').val();
        if (query.trim()) {
            performSearch(query);
        }
    });
    
    // Close button click handler
    $('#search-close-button').on('click', function() {
        closeSearchOverlay();
    });
    
    function openSearchOverlay() {
        var $overlay = $('#search-overlay');
        
        $overlay.addClass('show').css('display', 'block');
        $('body').css('overflow', 'hidden'); // Prevent scrolling
        $('#search-close-button').show(); // Show close button
        
        // Focus on input after a small delay to ensure overlay is visible
        setTimeout(function() {
            $('#search-input').focus();
        }, 100);
    }
    
    function closeSearchOverlay() {
        $('#search-overlay').removeClass('show').css('display', 'none');
        $('body').css('overflow', ''); // Restore scrolling
        $('#search-suggestions').hide();
        $('#search-close-button').hide(); // Hide close button
        currentHighlighted = -1;
    }
    
    function updateHighlight($items) {
        $items.each(function(index) {
            $(this).toggleClass('highlighted', index === currentHighlighted);
        });
    }
    
    function selectSuggestion(suggestion) {
        $('#search-input').val(suggestion);
        performSearch(suggestion);
    }
    
    function performSearch(query) {
        if (query.trim()) {
            window.location.href = '/search?q=' + encodeURIComponent(query.trim());
            // + '&type=product';
        }
    }
    
    function searchProducts(query) {
        var $suggestions = $('#search-suggestions');
        
        $.ajax({
            url: '/search/suggest.json',
            data: {
                q: query,
                'resources[type]': 'product',
                'resources[limit]': 8
            },
            dataType: 'json',
            success: function(data) {
                if (data.resources && data.resources.results && data.resources.results.products) {
                    displaySuggestions(data.resources.results.products);
                } else {
                    $suggestions.hide();
                }
            },
            error: function() {
                console.error('Search error');
                $suggestions.hide();
            }
        });
    }
    
    function displaySuggestions(products) {
        var $suggestions = $('#search-suggestions');
        currentHighlighted = -1;
        
        if (products.length === 0) {
            $suggestions.hide();
            return;
        }
        
        var suggestionsHtml = products.map(function(product) {
            var productUrl = product.url || '/products/' + product.handle;
            return '<div class="search-suggestion-item" data-url="' + productUrl + '">' + product.title + '</div>';
        }).join('');
        
        $suggestions.html(suggestionsHtml).show();
    }

    var sizeRe = /^(XXS|XS|S|M|L|XL|XXL|XXXL)$/i;

    function flattenRichText(node) {
        if (!node) {
            return '';
        }
        if (typeof node === 'string') {
            return node;
        }
        if (node.type === 'text') {
            return node.value || '';
        }
        if (!node.children || !node.children.length) {
            return '';
        }
        return node.children.map(flattenRichText).join('');
    }

    function cellsFromRichText(node, cells) {
        if (!node) {
            return;
        }
        if (typeof node === 'string') {
            node.split(/\n+/).forEach(function(part) {
                part = part.replace(/\u00a0/g, ' ').trim();
                if (part) {
                    cells.push(part);
                }
            });
            return;
        }
        if (node.type === 'paragraph' || node.type === 'heading' || node.type === 'list-item') {
            var text = flattenRichText(node).replace(/\u00a0/g, ' ').trim();
            if (text) {
                cells.push(text);
            }
            return;
        }
        if (node.children && node.children.length) {
            node.children.forEach(function(child) {
                cellsFromRichText(child, cells);
            });
        }
    }

    function normalizeMashedTable(text) {
        if (text.indexOf('\t') === -1) {
            return text;
        }
        var tokens = ['XXXL', 'XXL', 'XXS', 'XL', 'XS', 'S', 'M', 'L'];
        text = text.replace(/length(XXXL|XXL|XXS|XL|XS|S|M|L)(?=\t)/gi, 'length\t$1');
        tokens.forEach(function(token) {
            if (token.length > 1) {
                text = text.replace(new RegExp('([\\d.])((' + token + ')(?=\\t))', 'gi'), '$1\t$2');
            }
        });
        text = text.replace(/(\d\.\d+)(S|M|L)(?=\t)/g, '$1\t$2');
        text = text.replace(/(\d)(XL|XXL|XXXL|XS|XXS)(?=\t)/gi, '$1\t$2');
        return text;
    }

    function rowsFromFlatCells(flatCells) {
        var cols = 0;
        for (var i = 0; i < flatCells.length; i++) {
            if (sizeRe.test(flatCells[i])) {
                cols = i;
                break;
            }
        }
        if (cols < 2 || flatCells.length <= cols) {
            return null;
        }
        var trimmed = flatCells.slice();
        var extra = trimmed.length % cols;
        if (extra !== 0 && extra < cols) {
            trimmed = trimmed.slice(0, trimmed.length - extra);
        }
        if (trimmed.length % cols !== 0) {
            return null;
        }
        var out = [];
        for (var r = 0; r < trimmed.length; r += cols) {
            out.push(trimmed.slice(r, r + cols));
        }
        return out.length >= 2 ? out : null;
    }

    function buildSizeChartTable($block) {
        var $source = $block.find('.js-product-size-chart-source');
        var $fallback = $block.find('.js-product-size-chart-fallback');
        var $json = $block.find('.js-product-size-chart-json');
        var raw = normalizeMashedTable($source.text().replace(/\u00a0/g, ' ').replace(/\r\n/g, '\n').trim());
        var rows = null;
        var maxCols = 0;

        if (raw.indexOf('\t') !== -1) {
            var flatCells = raw.replace(/\n/g, '').split('\t').map(function(cell) {
                return cell.trim();
            }).filter(function(cell) {
                return cell.length > 0;
            });
            rows = rowsFromFlatCells(flatCells);
            if (rows) {
                maxCols = rows[0].length;
            }
        }

        var lines = raw.split('\n').map(function(line) {
            return line.trim();
        }).filter(function(line) {
            return line.length > 0 && !/^\|?[\s-:|]+$/.test(line);
        });

        if (!rows) {
            rows = lines.map(function(line) {
                var cells;
                if (line.indexOf('\t') !== -1) {
                    cells = line.split('\t');
                } else if (line.indexOf('|') !== -1) {
                    cells = line.split('|');
                } else if (line.indexOf(';') !== -1) {
                    cells = line.split(';');
                } else if (line.indexOf(',') !== -1) {
                    cells = line.split(',');
                } else {
                    cells = line.split(/ {2,}/);
                }
                return cells.map(function(cell) {
                    return cell.replace(/^\|+|\|+$/g, '').trim();
                }).filter(function(cell) {
                    return cell.length > 0;
                });
            }).filter(function(cells) {
                return cells.length > 0;
            });

            rows.forEach(function(cells) {
                if (cells.length > maxCols) {
                    maxCols = cells.length;
                }
            });
        }

        if (maxCols < 2) {
            var cells = [];
            if ($json.length) {
                try {
                    cellsFromRichText(JSON.parse($json.text()), cells);
                } catch (e) {
                    cells = [];
                }
            }
            if (cells.length < 4) {
                $fallback.find('p, li, h1, h2, h3, h4, h5, h6').each(function() {
                    var html = $(this).html() || '';
                    html.split(/<br\s*\/?>/i).forEach(function(part) {
                        var text = $('<div>').html(part).text().replace(/\u00a0/g, ' ').trim();
                        if (text) {
                            cells.push(text);
                        }
                    });
                });
            }
            if (cells.length < 4) {
                cells = lines.slice();
            }

            for (var m = 1; m < cells.length; m++) {
                if (/^length$/i.test(cells[m]) && /sleeve/i.test(cells[m - 1])) {
                    cells[m - 1] = cells[m - 1] + ' ' + cells[m];
                    cells.splice(m, 1);
                    m -= 1;
                }
            }

            var cols = 0;
            for (var i = 0; i < cells.length; i++) {
                if (sizeRe.test(cells[i])) {
                    cols = i;
                    break;
                }
            }

            if (cols >= 2 && cells.length > cols) {
                var extra = cells.length % cols;
                if (extra !== 0 && extra < cols) {
                    cells = cells.slice(0, cells.length - extra);
                }
                if (cells.length % cols === 0) {
                    rows = [];
                    for (var r = 0; r < cells.length; r += cols) {
                        rows.push(cells.slice(r, r + cols));
                    }
                    maxCols = cols;
                }
            }
        }

        if (rows.length < 2 || maxCols < 2) {
            return null;
        }

        while (maxCols > 1) {
            var colUsed = rows.some(function(rowCells) {
                return (rowCells[maxCols - 1] || '') !== '';
            });
            if (colUsed) {
                break;
            }
            maxCols -= 1;
        }
        if (maxCols < 2) {
            return null;
        }

        var tableHtml = '<div class="product-size-chart-wrap"><table class="product-size-chart">';
        rows.forEach(function(rowCells, rowIndex) {
            tableHtml += rowIndex === 0 ? '<thead><tr>' : (rowIndex === 1 ? '<tbody><tr>' : '<tr>');
            for (var c = 0; c < maxCols; c++) {
                var value = String(rowCells[c] || '')
                    .replace(/&/g, '&amp;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;');
                if (rowIndex === 0 || c === 0) {
                    tableHtml += '<th' + (rowIndex > 0 ? ' scope="row"' : '') + '>' + value + '</th>';
                } else {
                    tableHtml += '<td>' + value + '</td>';
                }
            }
            tableHtml += '</tr>';
            if (rowIndex === 0) {
                tableHtml += '</thead>';
            }
        });
        tableHtml += '</tbody></table></div>';
        return tableHtml;
    }

    $('.js-product-size-chart-block').each(function() {
        var $block = $(this);
        var tableHtml = buildSizeChartTable($block);
        if (tableHtml) {
            $block.find('.js-product-size-chart-fallback').remove();
            $block.append(tableHtml);
        }
    });

    $(document).on('click', '.product-size-chart-toggle__btn', function() {
        var $btn = $(this);
        var unit = $btn.data('unit');
        var $panel = $btn.closest('.product-sizing-panel');

        $btn.addClass('is-active').siblings('.product-size-chart-toggle__btn').removeClass('is-active');
        $panel.find('.js-product-size-chart-block').removeClass('product-size-chart-block--active');
        $panel.find('.js-product-size-chart-block[data-unit="' + unit + '"]').addClass('product-size-chart-block--active');
    });

    // Product detail accordions
    $(document).on('click', '.product-details-accordion__heading', function(event) {
        event.preventDefault();

        var $item = $(this).parent();
        var $content = $item.children('.product-details-accordion__content');

        if ($item.prop('open')) {
            $content.stop(true, true).slideUp(250, function() {
                $item.removeAttr('open');
            });
        } else {
            $item.attr('open', 'open');
            $content.hide().stop(true, true).slideDown(250);
        }
    });
});